
import React from 'react';
import PropTypes from 'prop-types';

import {
  StyledOptionField,
  StyledOptionStack,
  StyledSpacedOptionFields,
} from '../../../components/common/AnnotationOptions/AnnotationOptions.styled';
import restrictNumber from '../../../utils/restrictNumber';
import Slider from '../../../components/common/Slider';
import {
  POLYGON_SIDES_MAX,
  POLYGON_SIDES_MIN,
} from './Polygon.constants';

const POPUP_SLIDER_WIDTH = '100%';

const PolygonSidesField = ({
  annotation: polygon,
  updateAnnotation: updatePolygon,
  t,
}) => {
  const { sides } = polygon;

  const clampedSides = restrictNumber(sides, POLYGON_SIDES_MIN, POLYGON_SIDES_MAX);

  const updateSidesNumber = (newSidesNumber) => {
    updatePolygon({
      sides: restrictNumber(newSidesNumber, POLYGON_SIDES_MIN, POLYGON_SIDES_MAX),
    });
  };

  return (
    <StyledSpacedOptionFields className="respark_annotation-option-panel">
      <StyledOptionStack>
        <StyledOptionField>
          <Slider
            width={POPUP_SLIDER_WIDTH}
            annotation=""
            onChange={updateSidesNumber}
            value={clampedSides}
            min={POLYGON_SIDES_MIN}
            max={POLYGON_SIDES_MAX}
          />
        </StyledOptionField>
      </StyledOptionStack>
    </StyledSpacedOptionFields>
  );
};

PolygonSidesField.propTypes = {
  annotation: PropTypes.instanceOf(Object).isRequired,
  updateAnnotation: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default PolygonSidesField;
